import React from "react";
import { ActionProps } from "react-querybuilder";

export const CustomCloneRuleAction: React.FC<ActionProps> = (props) => {
    return null;
};
